export default function Subscribe () {

  return (
  <div class="ctct-inline-form" data-form-id="76b78c3d-29e0-4c67-be12-d3d51c56cbeb"></div>
  )
}